<script>
    const langRu = require('./translations/ru.js');
    const langUa = require('./translations/ua.js');

    export default {
        name: "LangManager",
        methods: {
            $t(name) {
                return this.getLangPackage()[name];
            },
            getLangPackage() {
                switch(this.$store.state.language.appLanguage) {
                    case 'ru' : return langRu.default;
                    case 'ua' : return langUa.default;

                    default: return langRu;
                }
            }
        }
    }
</script>

<style scoped>

</style>
